import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { liveGageTheme } from './contexts/theme';


// const root = ReactDOM.createRoot(document.getElementById('root'));
const widgetDiv =  document.getElementById('chat-window');



const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
  const pair = vars[i].split('=');
  if (pair[0] === variable) {
  return pair[1];
  }
  }
  return null;
 }


const scriptUrl = document.currentScript.src;
//console.log('scriptUrl',scriptUrl,Boolean(queryParams.get('isMobile'))
const queryParams = new URLSearchParams(scriptUrl.split('?')[1]);
console.log('scriptUrl',scriptUrl,Boolean(queryParams.get('isMobile')))


if((Boolean(getQueryVariable('isMobile')))){





var loanid = getQueryVariable('param1');
 var userid = getQueryVariable('param2');
 var isloggedin = getQueryVariable('param3');
 var sender =   getQueryVariable('param4');
 var  firstname = getQueryVariable('param5');
 var theme =  getQueryVariable('param6');
 var loginstatus =  getQueryVariable('param7');
 var isMobile = getQueryVariable('isMobile');
 var profileparam = getQueryVariable('profile');
 var profile = decodeURIComponent(profileparam);
 console.log('decoded profile url',profile);
 var appliedTheme = liveGageTheme;



}
if(queryParams.get('isMobile') == 'false'){

  var loanid = queryParams.get('param1');

  var userid = queryParams.get('param2');

var isloggedin = queryParams.get('param3');

var sender = queryParams.get('param4');

var firstname = queryParams.get('param5');

var theme = queryParams.get('param6');

var loginstatus = queryParams.get('param7');

var isMobile = queryParams.get('isMobile');

 var appliedTheme = queryParams.get('param8');
 var profile = queryParams.get('profile');

  

}


  // console.log('attribute..',applied_theme)
//   const theme =widgetDiv.dataset.theme
//   console.log('data attribute..',theme);
//   //appliedTheme = JSON.parse(decodeURIComponent(theme));
// }
// else{
//   appliedTheme = liveGageTheme

// }



//var  appliedTheme ;


//  const loanid = getQueryVariable('param1');
//  const userid = getQueryVariable('param2');
//  const isloggedin = getQueryVariable('param3');
//  const sender =   getQueryVariable('param4');//
//  const  firstname = getQueryVariable('param5');
//  const theme =  getQueryVariable('param6');
//  const loginstatus =  getQueryVariable('param7');
//  var applied_theme = getQueryVariable('param8');
//  const  appliedTheme = JSON.parse(decodeURIComponent(applied_theme));


 
console.log('query param.....response',loanid,userid,isloggedin,sender,firstname,theme,loginstatus,profile)

ReactDOM.render(
  <React.StrictMode>
    
    {/* <App isloggedin={widgetDiv.dataset.isloggedin} sender={widgetDiv.dataset.sender} loanid={widgetDiv.dataset.loanid}/> */}
    <BrowserRouter>

   {/* <App domElement={widgetDiv} /> */}
   <App profile={profile} domElement={widgetDiv}  isloggedin={isloggedin} isMobile={isMobile} firstname={firstname} sender={sender} loanid={loanid}  loginstatus={loginstatus} theme={theme} userid={userid} appliedTheme={appliedTheme} />
   </BrowserRouter>
   
  </React.StrictMode>,
 document.getElementById('chat-window')
);
